import React, { useState, useEffect, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { useToasts } from 'react-toast-notifications'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'assets/css/react-confirm-alert.css'; // Import css
import { CircularProgress } from '@material-ui/core';
import Box from '@material-ui/core/Box';


import styles from 'assets/jss/material-dashboard-react/views/dashboardStyle.js';
import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import Table from 'components/Table/Table.js';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import Card from 'components/Card/Card';
import Button from 'components/CustomButtons/Button.js';

import api from '../../services/api';

const useStyles = makeStyles(styles);

export default function ProductComposition() {
  const classes = useStyles();  
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const { addToast } = useToasts()

  useEffect(() => {
      getData();
  }, []);


  const getData = useCallback(async () => {

    try {
      
      setLoading(true);
      const response = await api.get("/productComposition");
      const items = [];
      response.data.map(r => {

        items.push({
          id: r.id,
          productTypeName: r.productType.name,
          colorName: r.color.name,
          jarName: r.jar.name,
          vistacima: r.photos?.find(p => p.vistacima === true)?.image_name,
          destaque: r.photos?.find(p => p.destaque === true)?.image_name
        })

      });


      console.log(items);
      setData(items);
      setLoading(false);
    }
    catch(e){
      addToast('Ocorreu um erro para atualizar os dados', {
        appearance: 'error',
        autoDismiss: true,
      });     
      setLoading(false);   
    } 

  },[]);

  const handleDelete = useCallback(async (id) => {

    confirmAlert({
      title: 'Confirmação',
      message: 'Tem certeza que deseja remover este registro ?',
      buttons: [
        {
          label: 'Sim',
          onClick: () => postDeleteAction(id)
        },
        {
          label: 'Não'         
        }
      ]
    });

  },[]);

  const postDeleteAction =  useCallback(async (id) => {
      try {
          await api.delete(`/productComposition/${id}`);
          setData(data => data.filter(d => d.id != id));
          setLoading(false);
      }
      catch(e){
        addToast(e.response.data.message, {
          appearance: 'error',
          autoDismiss: true,
        });             
      }
  },[]);

  
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card> 
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>Composições de Produto</h4>
            <p className={classes.cardCategoryWhite}>
              Lista de composições de produtos cadastradas no sistema.
            </p>
          </CardHeader>
          <CardBody>

          <Link to="/admin/compositions/new"> <Button color="info">Adicionar nova composição de produto</Button></Link>
 
          {data && data.length > 0 ? <Table
              tableHeaderColor="primary" 
              tableHead={['Imagem Topo', 'Imagem Frontal', 'Tipo de produto', 'Cor', 'Jarra', '', '', '']}
              tableColumn={['topImage', 'frontalImage', 'productTypeName', 'colorName', 'jarName', 'foto', 'edit', 'delete']}
              tableColumnSize={['10%', '10%', '25%', '25%', '25%', '1%', '1%', '1%']}
              tableData={data} 
              resource="compositions"
              onDelete={(id) => handleDelete(id)}
              onAddPhoto={(id) => history.push(`/admin/compositions/images/${id}`)}
           /> : isLoading ? (
            <Box mt={6}>
             <CircularProgress />
            </Box>               
          ) : (           
            <p style={{marginTop: 20}}>Nenhuma composição de produto cadastrado no momento.</p>
          )}
          </CardBody>
        </Card>
      </GridItem>

    </GridContainer>
  );
}
